import type { NextApiRequest, NextApiResponse } from 'next';
import { isPhone } from 'base/utils/client';
import { IPageConfig } from 'mod/brochure/interface';
import { themes } from 'base/api/featureConfig/config';
import { mockM } from './mockM';
import { mockPC } from './mockPC';

export function mockConfig(theme: string | string[] | undefined): IPageConfig {
    const config: IPageConfig = {
        // variantId: '144564522838020119',
        // onSaleTime: '2024-06-12 09:24:00', //UTC 时间
        // disableActions: [],//'addToCart', 'buyNow'
        features: isPhone ? mockM : mockPC
    };

    if (Array.isArray(theme)) {
        theme = theme[0];
    }
    if (!!theme) {
        config.containerTheme = themes[theme];
    }

    return config;
}

export default async function success(req: NextApiRequest, res: NextApiResponse<any>) {
    res.json({
        code: 0,
        data: mockConfig(req.query.theme),
        message: 'success',
        success: true
    });
}
